import axios from "../../department-viags/config.service";

export interface Permission {
  id: number;
  code: string;
  permissionName: string;
  description?: number;
  note?: string;
}

export type PermissionParams = {
  roleId?: number;
  permissionId: number;
  c: boolean;
  r: boolean;
  u: boolean;
  d: boolean;
  description?: string;
  note?: string;
  id?: number;
};

export class PermissionService {
  static async getList() {
    const res = await axios.get<{ data: Permission[]; statusCode: number }>("/permission/get-list");
    return res.data.data;
  }
}
